"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssIcon = exports.css = void 0;

var _util = require("../../../util");

const css = ({
  cssProps,
  theme
}) => {
  const {
    size = 'large',
    variant = 'google',
    width = 'inline',
    isLoading
  } = cssProps;
  const isFullWidth = width === 'full';
  const isSmall = size === 'small';
  const variantTheme = theme.buttonSocial[variant];
  return { ...(0, _util.textStyle)(theme, isSmall ? 'meta' : 'body'),
    alignItems: 'center',
    background: (0, _util.color)(theme, variantTheme.bg),
    borderRadius: variantTheme.borderRadius,
    boxShadow: (0, _util.boxShadow)(theme, variantTheme.boxShadow),
    color: (0, _util.color)(theme, variantTheme.color),
    cursor: 'pointer',
    display: 'flex',
    fontWeight: 'bold',
    height: isSmall ? variantTheme.smallHeight : variantTheme.height,
    lineHeight: 1,
    justifyContent: 'center',
    padding: (0, _util.spacing)(theme, ['none', isSmall ? variantTheme.smallPaddingX : variantTheme.paddingX]),
    transition: 'color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease',
    width: isFullWidth ? '100%' : undefined,
    pointerEvents: isLoading ? 'none' : undefined,
    ':active': {
      background: (0, _util.color)(theme, variantTheme.activeBg),
      boxShadow: (0, _util.boxShadow)(theme, variantTheme.activeBoxShadow)
    },
    ':hover': {
      background: (0, _util.color)(theme, variantTheme.hoverBg),
      boxShadow: (0, _util.boxShadow)(theme, variantTheme.hoverBoxShadow),
      color: (0, _util.color)(theme, variantTheme.hoverText)
    },
    ':disabled': {
      background: (0, _util.color)(theme, variantTheme.disabledBg),
      boxShadow: (0, _util.boxShadow)(theme, variantTheme.disabledBoxShadow),
      color: (0, _util.color)(theme, variantTheme.disabledColor),
      cursor: 'not-allowed',
      ':hover': {
        background: (0, _util.color)(theme, variantTheme.disabledBg),
        boxShadow: (0, _util.boxShadow)(theme, variantTheme.disabledBoxShadow),
        color: (0, _util.color)(theme, variantTheme.disabledColor)
      }
    }
  };
};

exports.css = css;

const cssIcon = ({
  cssProps,
  theme
}) => {
  const {
    size = 'large'
  } = cssProps;
  const {
    buttonSocial: buttonSocialTheme
  } = theme;
  const isSmall = size === 'small';
  return {
    height: isSmall ? buttonSocialTheme.size.small : buttonSocialTheme.size.large,
    width: isSmall ? buttonSocialTheme.size.small : buttonSocialTheme.size.large
  };
};

exports.cssIcon = cssIcon;
//# sourceMappingURL=ButtonSocial.style.js.map